export default "__VITE_ASSET__CtDanMRC__"